import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { registerLocaleData } from '@angular/common';
import localeCy from '@angular/common/locales/cy';

// Welsh locale data for locale-aware pipes (e.g. diary dates in Cymraeg mode).
registerLocaleData(localeCy, 'cy');

if (environment.production) {
  enableProdMode();
  // disable console.log in production
  console.log = (..._args: any[]) => { };
}
// console.log = (..._args: any[]) => { };


platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));